import * as React from 'react';

export interface IVariantNameProps {
    variantName?: string;
    bikeAssociationName?: string;
}

export const VariantNameComponent: React.FunctionComponent<IVariantNameProps> = props => {
    return (
        <>
            {
                props.variantName
            }
            {
                props.bikeAssociationName && <span id="bike-assoc-property" className="bike-assoc-property">[{props.bikeAssociationName}]</span>
            }
        </>
    );
}
